<template>
  <div id="trend-data-details">
    <div id="side-container">
      <div class="title-text">データレポート</div>
    </div>
    
    <div id="main-container">
      <div class="data-report-menu-area">
        <div class="data-report-menu-item">
        </div>
      </div>
      <div id="chart-column-header" class="sdf-text-14-400-mouse-gray">
        <div class="column-header-text column-channel-id">CH番号</div>
        <div class="column-header-text column-channel-name">CH名</div>
        <div class="column-header-text column-value-normal">基準値</div>
        <div class="column-header-text column-value">値</div>
        <div class="column-header-text column-unit">単位</div>
        <div class="column-header-text column-chart">チャート</div>
      </div>
      <div v-if="on">
        <trend-data-chart
          :xAxisValue.sync="xAxisValue"
          ref="child">
        </trend-data-chart>
      </div>
    </div>
  </div>
</template>

<script>
import TrendDataChart from "./TrendDataChart"
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin"

export default {
  name: "trendDataDetails",
  mixins: [SecureDataflowMixin],
  components: {
    TrendDataChart,
  },
  data() {
    return {
      on: true,
      xAxisValue: 0,
    }
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/_variables.scss";

#trend-data-details{
  background-color: $sdf-dark-blue-navy;
  color: $sdf-white;
  display: flex;
  #side-container {
    min-width: 220px;
    padding: 30px;
  }

  .menu-item-icon {
    position: absolute;
    margin-top: 4px;
  }

  .effect {
    background: $sdf-blue !important;
  }
  .vs-pagination--buttons {
    background: transparent !important;
    color: $sdf-white;
  }

  .vs-pagination--ul {
    background: $sdf-navy;
  }
  .vs-pagination--li {
    color: $sdf-white;
  }

  #main-container {
    width: 100%;
    padding-left: 30px;
    overflow-y: scroll;
  }
  .control-area {
    display: flex;
  }
  .data-report-menu-area {
    display: flex;
    justify-content: flex-end;
  }

  .data-report-menu-item {
    margin: 14px;
    cursor: pointer;
    p {
      font-size: 16px;
      padding-left: 22px;
    }
  }

  .title-text {
    font-size: 22px;
  }
  .side-switch {
    margin-top: 20px;
    margin-bottom: 30px;
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    width: 120px;
    font-size: 16px;
  }
  .side-switch-area {
    margin-top: 40px;
  }
  .side-menu-item {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
  .engine-data-chart-container {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  #chart-column-header {
    display: flex;
    border-bottom: solid;
    border-width: 1px;
    border-color: $sdf-gray;
  }

  .column-alerm {
    min-width: 60px;
  }

  .column-channel-id {
    min-width: 60px;
  }
  .column-channel-name {
    width: 360px;
  }
  .column-value-normal {
    min-width: 100px;
    padding-left: 3rem;
    font-size: 18px;
  }
  .column-value {
    min-width: 100px;
    padding-right: 20px;
    text-align: right;
  }
  .column-unit {
    min-width: 80px;
  }
  .column-status {
    min-width: 80px;
  }
  .column-chart {
    min-width: 220px;
  }

  .column-header-text {
    font-size: 14px;
    color: $sdf-light-navy;
  }
}
</style>
